import React from 'react';
import { InternalLink, InternalLinkProps } from 'components/InternalLink';
import { ExternalLink, ExternalLinkProps } from 'components/ExternalLink';
import { isInternalUrl } from 'helpers/isInternalUrl';

type PrismicLinkProps = InternalLinkProps & ExternalLinkProps;

export const PrismicLink = ({ label, link, className, children, slice }: PrismicLinkProps) =>
    link ? (
        isInternalUrl(link.url) ? (
            <InternalLink
                label={label}
                link={link}
                className={className}
                children={children}
                slice={slice}
            />
        ) : (
            <ExternalLink
                label={label}
                link={link}
                className={className}
                children={children}
                slice={slice}
            />
        )
    ) : null;
